import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class AccountsReceivableSettlement {
  // 进仓列表
  static getEnterWarehouseList(options) {
    let url = '/zwy/api/cb/logistics/bill/imports/fee/list?'
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 应付进仓列表
  static getPayEnterWarehouseList(options) {
    let url = '/zwy/api/cb/logistics/bill/payable/imports/fee/list?'
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 出仓列表
  static getExitWarehouseList(options) {
    let url = '/zwy/api/cb/logistics/bill/exports/fee/list?'
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 应付出仓列表
  static getPayExitWarehouseList(options) {
    let url = '/zwy/api/cb/logistics/bill/payable/exports/fee/list?'
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 存储费用结算列表
  static getStorageFeeList(options) {
    let url = '/zwy/api/cb/logistics/bill/rent/fee/list?'
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 结算
  static postSettlement(data) {
    const url = '/zwy/api/cb/logistics/bill/create'
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 应付结算
  static postPaySettlement(data) {
    const url = '/zwy/api/cb/logistics/bill/payable/create'
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
}

export default AccountsReceivableSettlement